<template>
	<div class="p-mb-6 InputSrTable">
		<div class="table-header-bar">
			<h3 class="table-title">{{ question }}</h3>
			<div class="table-actions">
				<ToggleButton
					v-model="ifEdit"
					onIcon="pi pi-check"
					offIcon="pi pi-user-edit"
					offLabel="Save"
					class="premium-toggle-btn"
				/>
				<Button
					icon="pi pi-cloud-download"
					@click="isShowDialog = true"
					class="p-button-secondary p-button-text premium-export-btn"
				/>
			</div>
		</div>
		<div class="table-container">
			<table
				class="p-fluid"
				v-if="value && value != undefined"
			>
				<thead class="p-fluid-thead">
					<tr>
						<th v-for="(thead, index) in value.headers" :key="index" :class="['col-' + thead.name]">
							<div class="th_container">
								<div class="name">
									{{ thead.label }}
								</div>
								<div class="menu">
									<InputSrMenubar
										v-if="ifEdit"
										:colIndex="index"
										@addCol="addCol"
										@deleteCol="deleCol"
									/>
								</div>
							</div>
						</th>
						<th v-if="ifEdit" class="actions-header-cell">
							<div class="th_container actions-header-content">Actions</div>
						</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="(row, index) in value.rows" :key="index">
						<td v-for="(thead, colIndex) of value.headers" :key="colIndex" :class="['col-' + thead.name]">
							<template v-if="thead.name == 'toolLink'">
								<div
									v-for="tl in row.toolLink"
									:key="tl.name"
									class="tool-link-item"
								>
									<a
										v-if="
											tl.name != '' && tl.link.includes('https://') == false
										"
										:href="methodsUrl + tl.link"
										target="_blank"
										class="premium-link"
										>{{ tl.name }}</a
									>
									<a
										v-if="tl.name != '' && tl.link.includes('https://') == true"
										:href="tl.link"
										target="_blank"
										class="premium-link"
										>{{ tl.name }}</a
									>
								</div>
							</template>
							<div
								class="checkbox-wrapper-29 checkbox-center"
								v-if="thead.name == 'progress'"
							>
								<label class="checkbox">
									<input
										type="checkbox"
										v-model="row.progress"
										class="checkbox__input"
										@change="changeHandler($event)"
									/>
									<span class="checkbox__label"></span>
								</label>
							</div>
							<NotesContent
								v-if="thead.name == 'notes'"
								:thead="thead"
								:row="row"
								@notes="changeHandler"
							/>
							<InputAutoComplete
								:isEvenRow="isEvenRow(index)"
								v-if="thead.name == 'peopleInvolved'"
								:row="row"
								:titlePageAuthors="titlePageAuthors"
								@autocom="authChangeHandler"
							/>
							<Textarea
								v-if="
									thead.name != 'peopleInvolved' &&
										thead.name != 'toolLink' &&
										thead.name != 'progress' &&
										thead.name != 'notes'
								"
								type="text"
								:value="row[thead.name]"
								:ref="index"
								:autoResize="true"
								@change="handleCellChange(row, thead.name, $event.target.value)"
							/>
							<!--@change="changeHandler($event.target.value)"-->
						</td>
						<td class="btnArea" v-if="ifEdit">
							<div class="row-action-buttons">
								<Button
									class="p-button-rounded p-button-text p-button-secondary action-trigger-btn"
									icon="pi pi-ellipsis-h"
									@click="show = !show"
								/>
								<div class="action-buttons-popover" v-if="show">
									<Button
										class="p-button-rounded p-button-text action-btn"
										icon="pi pi-arrow-up"
										title="Add Row Above"
										@click="addRow(index, 0)"
									/>
									<Button
										class="p-button-rounded p-button-text p-button-danger action-btn"
										icon="pi pi-trash"
										title="Delete Row"
										@click="deleRow(index)"
									/>
									<Button
										class="p-button-rounded p-button-text action-btn"
										icon="pi pi-arrow-down"
										title="Add Row Below"
										@click="addRow(index, 1)"
									/>
								</div>
							</div>
						</td>
					</tr>
				</tbody>
			</table>
		</div>
		<Dialog header="Export to Excel" :visible.sync="isShowDialog" :modal="true">
			<div class="p-inputgroup">
				<span class="p-inputgroup-addon">NewFile-Name:</span>
				<InputText placeholder="e.g.ResearchPlan.xlsx" v-model="fileName" />
			</div>

			<template #footer>
				<Button
					label="Cancel"
					icon="pi pi-times"
					class="p-button-text"
					@click="isShowDialog = false"
				/>
				<Button
					label="Confirm"
					icon="pi pi-check"
					class="p-button-text"
					@click="exportExcel(value.rows, value.headers, fileName)"
				/>
			</template>
		</Dialog>
	</div>
</template>
<script>
import Textarea from "primevue/textarea";
import Button from "primevue/button";
//import AutoComplete from "primevue/autocomplete";
import Dialog from "primevue/dialog";
import InputText from "primevue/inputtext";
import ToggleButton from "primevue/togglebutton";

import * as XLSX from "xlsx";
import InputAutoComplete from "@/components/InputAutoComplete.vue";
import InputSrMenubar from "../components/InputSrMenubar.vue";
import NotesContent from "./NotesContent.vue";

import Vue from "vue";
import VueExcelEditor from "vue-excel-editor";
Vue.use(VueExcelEditor);
export default {
	name: "InputSrTable",
	components: {
		Textarea,
		Button,
		Dialog,
		InputText,
		InputAutoComplete,
		InputSrMenubar,
		NotesContent,
		ToggleButton
	},
	props: {
		question: String,
		titlePageAuthors: Array,
		value: {}
	},
	data() {
		return {
			//filteredPeople: null,
			ifEdit: false,
			show: false,
			isShowDialog: false,
			fileName: "",
			methodsUrl: "",
			jsondata: [],
			toolLinkName: "",
			people: []
		};
	},
	methods: {
		authChangeHandler(ifadd, row, event) {
			console.log(
				"ifadd:" +
					ifadd +
					", row:" +
					JSON.stringify(row) +
					", event:" +
					JSON.stringify(event)
			);
			this.$emit("authChangeHandler", ifadd, row, event);
		},
		changeHandler(event) {
			if (event != undefined) {
				console.log("input", this.value);
				this.$emit("input", this.value);
			}
		},
		handleCellChange(row, field, newValue) {
			this.$set(row, field, newValue);
			this.$emit("input", this.value);
		},
		isEvenRow(index) {
			return index % 2 === 0;
		},
		addRow(index, optionNum) {
			let row = {};
			for (var i = 0; i < this.value.headers.length; i++) {
				if (this.value.headers[i].name == "progress") {
					row[this.value.headers[i].name] = {
						isComplete: "false",
						state: "Incomplete"
					};
				} else {
					row[this.value.headers[i].name] = "";
				}
				this.$set(row, row[this.value.headers[i].name]);
			}
			if (optionNum == 0) {
				this.value.rows.splice(index, 0, row);
			} else {
				this.value.rows.splice(index + 1, 0, row);
			}
			this.$emit("input", this.value);
		},
		deleRow(index) {
			this.value.rows.splice(index, 1);
			this.$emit("input", this.value);
		},
		deleCol(index) {
			this.value.headers.splice(index, 1);
			this.$delete(this.value.rows, this.value.headers[index].name);
			this.$emit("input", this.value);
		},
		addCol(newC) {
			let colName = newC.ColLabel.trim();
			colName = colName.replace(/\s+/g, "");
			let thead = {
				name: colName,
				label: newC.ColLabel
			};
			if (newC.LorR == 0) {
				this.value.headers.splice(newC.Index, 0, thead);
			} else {
				this.value.headers.splice(newC.Index + 1, 0, thead);
			}
			this.$emit("input", this.value);
			/*this.rsValue.forEach(i => {
				this.$set(this.value.rows[i], colName, "");
			});*/
		},
		exportExcel(rows, headers, fileName) {
			let workbook = XLSX.utils.book_new();
			let xlsxData = this.convertJson(rows, headers);
			let sheet1 = XLSX.utils.json_to_sheet(xlsxData);
			// Formating Cells on excel
			const jsonKeys = headers ? headers : Object.keys(rows[0]);
			let objectMaxLength = [];
			let keysForPatch = [];
			for (let i = 0; i < rows.length; i++) {
				let value = rows[i];
				for (let j = 0; j < jsonKeys.length; j++) {
					keysForPatch.push(jsonKeys[j].name);
					if (typeof value[jsonKeys[j].name] == "number") {
						objectMaxLength[j] = 10;
					} else {
						const l = value[jsonKeys[j].name]
							? value[jsonKeys[j].name].length
							: 0;
						if (l && l != 1) {
							objectMaxLength[j] =
								objectMaxLength[j] >= l ? objectMaxLength[j] : l;
						} else {
							objectMaxLength[j] = j == 0 ? 10 : 40;
						}
					}
				}
				let key = keysForPatch;
				for (let j = 0; j < key.length; j++) {
					objectMaxLength[j] =
						objectMaxLength[j] >= key[j].length
							? objectMaxLength[j]
							: key[j].length;
				}
			}
			const wscols = objectMaxLength.map(w => {
				return { width: w };
			});
			sheet1["!cols"] = wscols;
			// sheet1['A1'].s = {
			// 	fill: {
			// 		patternType: "solid",
			// 		fgColor: { rgb: "00dce6f1" },
			// 		bgColor: { rgb: "00dce6f1" }
			// 	}
			// }
			XLSX.utils.book_append_sheet(workbook, sheet1, "ResearchPlan1");
			if (fileName != "") {
				XLSX.writeFile(workbook, fileName + ".xlsx");
			} else {
				XLSX.writeFile(workbook, "ResearchPlan.xlsx");
			}
			this.isShowDialog = false;
		},
		convertJson(rows, headers) {
			let xlsxData = [];
			rows.forEach(row => {
				let da = {};
				for (var i = 0; i < headers.length; i++) {
					if (headers[i].name == "peopleInvolved") {
						let authors = "";
						if (row[headers[i].name].length > 0) {
							row[headers[i].name].forEach(per => {
								authors += per.label + ",";
							});
						}
						this.$set(da, headers[i].label, authors);
					} else if (headers[i].name == "toolLink") {
						let link = "";
						if (row[headers[i].name].length > 0) {
							row[headers[i].name].forEach(tlink => {
								if (tlink.name != "") {
									link += tlink.name + ";";
								}
							});
						}
						this.$set(da, headers[i].label, link);
					} else {
						this.$set(da, headers[i].label, row[headers[i].name]);
					}
				}
				xlsxData.push(da);
			});
			return xlsxData;
		},
		validWholeRecord(content, oldContent, record, field) {
			console.log(content, oldContent, record, field);
			if (record.age !== record.birth) {
				return "The age and birth do not match";
			} else {
				return ""; // return empty string if there is no error
			}
		}
	},
	mounted() {
		this.methodsUrl = "/#";
	},
	computed: {
		dynamicColumnWidths() {
			const columnWidths = {};
			for (const column of this.value) {
				const fieldName = column.name;
				const contentLength = this.value.rows.reduce((maxLength, row) => {
					const content = row[fieldName] || "";
					return Math.max(maxLength, content.length);
				}, 0);
				// Calculate the width based on content length
				columnWidths[fieldName] = `${contentLength * 10 + 20}px`;
			}
			return columnWidths;
		},
		simplifiedJsondata() {
			return this.value.rows.map(item => ({
				...item,
				// toolLink: Array.isArray(item.toolLink) && item.toolLink.length > 0 ? item.toolLink[0].name : '',
				peopleInvolved:
					Array.isArray(item.peopleInvolved) && item.peopleInvolved.length > 0
						? item.peopleInvolved[0].label
						: ""
			}));
			// return this.value.rows.map((item) => {
			// 	const simplifiedUser = {
			// 		toolLink: Array.isArray(item.toolLink) ? item.toolLink[0].name : ''
			// 	};
			// 	console.log(this.value, simplifiedUser)

			// 	// Merge the simplified 'user' data with the rest of the item's data
			// 	return {
			// 		simplifiedUser,
			// 		item
			// 	};
			// });
		}
	}
};
</script>
<style>
/* Table Root Styling */
.InputSrTable table {
	border-collapse: collapse;
	border-spacing: 0;
	width: 100%;
	background-color: #ffffff;
	font-size: 0.9rem;
	table-layout: fixed;
}

.InputSrTable .table-container {
	overflow-x: auto;
	height: 60vh;
	border: 1px solid #e2e8f0;
	border-radius: 12px;
	box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.05), 0 8px 10px -6px rgba(0, 0, 0, 0.03);
	background: #ffffff;
}

/* Custom Scrollbar */
.InputSrTable .table-container::-webkit-scrollbar {
	width: 8px;
	height: 8px;
}
.InputSrTable .table-container::-webkit-scrollbar-track {
	background: #f8fafc;
	border-radius: 4px;
}
.InputSrTable .table-container::-webkit-scrollbar-thumb {
	background: #cbd5e1;
	border-radius: 4px;
	transition: background 0.2s ease;
}
.InputSrTable .table-container::-webkit-scrollbar-thumb:hover {
	background: #94a3b8;
}

/* Table Header Bar */
.InputSrTable .table-header-bar {
	display: flex;
	justify-content: space-between;
	align-items: center;
	margin-bottom: 1.25rem;
	padding: 0.5rem 0;
}

.InputSrTable .table-title {
	font-size: 1.25rem;
	font-weight: 700;
	color: #0f172a;
	margin: 0;
}

.InputSrTable .table-actions {
	display: flex;
	gap: 12px;
	align-items: center;
}

/* Toggle & Export Buttons */
.InputSrTable .premium-toggle-btn.p-button {
	background: #1e293b;
	border: 1px solid #1e293b;
	color: #ffffff;
	border-radius: 8px;
	font-weight: 600;
	font-size: 0.875rem;
	padding: 8px 18px;
	height: 38px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.InputSrTable .premium-toggle-btn.p-button:hover {
	background: #0f172a;
	border-color: #0f172a;
	transform: translateY(-1px);
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1);
}
.InputSrTable .premium-toggle-btn.p-button.p-highlight {
	background: linear-gradient(135deg, #10b981, #059669);
	border-color: #059669;
}
.InputSrTable .premium-toggle-btn.p-button.p-highlight:hover {
	background: linear-gradient(135deg, #059669, #047857);
	border-color: #047857;
}

.InputSrTable .premium-export-btn.p-button {
	background: #ffffff;
	border: 1px solid #e2e8f0;
	color: #475569;
	border-radius: 8px;
	font-weight: 600;
	font-size: 0.875rem;
	padding: 8px 18px;
	height: 38px;
	box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.InputSrTable .premium-export-btn.p-button:hover {
	background: #f8fafc;
	border-color: #cbd5e1;
	color: #1e293b;
	transform: translateY(-1px);
	box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.05);
}

/* Sticky Headers & Design */
.InputSrTable .p-fluid-thead {
	position: sticky;
	top: 0px;
	z-index: 10;
	border-bottom: 2px solid #2d3d62;
}

.InputSrTable th {
	background: linear-gradient(180deg, #486095, #354972) !important;
	color: #ffffff !important;
	font-weight: 600;
	border-bottom: 2px solid #2d3d62 !important;
	border-right: 1px solid rgba(255, 255, 255, 0.08) !important;
	border-left: 1px solid rgba(255, 255, 255, 0.08) !important;
	padding: 0;
}

.InputSrTable .th_container {
	display: flex;
	align-items: center;
	justify-content: space-between;
	padding: 12px 8px;
	box-sizing: border-box;
}

/* Custom Column Widths to fit table within page without scroll */
.InputSrTable th,
.InputSrTable td {
	word-wrap: break-word;
	overflow-wrap: break-word;
}

.InputSrTable .col-progress {
	width: 65px;
}

.InputSrTable .col-tasks {
	width: 15%;
}

.InputSrTable .col-toolDescription {
	width: 25%;
}

.InputSrTable .col-toolLink {
	width: 12%;
}

.InputSrTable .col-peopleInvolved {
	width: 23%;
}

.InputSrTable .col-notes {
	width: 25%;
}

.InputSrTable td.col-notes {
	position: relative;
}

.InputSrTable th.actions-header-cell,
.InputSrTable td.btnArea {
	width: 100px;
}

.InputSrTable .name {
	font-size: 0.8rem;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
	color: #f8fafc;
	opacity: 0.95;
}

.InputSrTable .menu {
	display: flex;
	align-items: center;
}

/* Table Cells */
.InputSrTable th,
.InputSrTable td {
	border: 1px solid #f1f5f9;
	transition: all 0.2s ease;
}

.InputSrTable td {
	padding: 0;
	vertical-align: middle;
	background-color: #ffffff;
	height: 100%;
}

/* Row Zebra Striping */
.InputSrTable tr {
	transition: background-color 0.2s ease;
}

.InputSrTable tr:nth-child(even) td {
	background-color: #f0f5fa;
}

.InputSrTable tr:hover td {
	background-color: #e2edf8;
}

/* Textarea styling within cell */
.InputSrTable textarea.p-inputtextarea {
	border: none !important;
	background: transparent !important;
	box-shadow: none !important;
	width: 100% !important;
	resize: none !important;
	padding: 14px 16px !important;
	font-size: 0.875rem !important;
	color: #334155 !important;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1) !important;
	display: block;
	min-height: 44px;
	border-left: 2px solid transparent !important;
}

.InputSrTable textarea.p-inputtextarea:focus {
	background-color: #ffffff !important;
	border-left: 2px solid #3b82f6 !important;
	box-shadow: inset 0 0 8px rgba(59, 130, 246, 0.05) !important;
	color: #0f172a !important;
	padding-left: 18px !important;
}

/* Tool links */
.InputSrTable .tool-link-item {
	margin: 8px 12px;
}

.InputSrTable .premium-link {
	color: #2563eb;
	text-decoration: none;
	font-weight: 600;
	font-size: 0.875rem;
	transition: all 0.2s ease;
	display: inline-flex;
	align-items: center;
	gap: 4px;
}
.InputSrTable .premium-link:hover {
	color: #1d4ed8;
	transform: translateX(2px);
}

/* Checkbox Column Centering */
.InputSrTable .checkbox-center {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 100%;
	height: 100%;
	padding: 10px 0;
}

/* Actions Column Header & Cell */
.InputSrTable .actions-header-cell {
	background: linear-gradient(180deg, #3b4e7a, #2d3d62) !important;
	min-width: 100px;
}

.InputSrTable .actions-header-content {
	justify-content: center;
	color: #ffffff;
	font-size: 0.8rem;
	font-weight: 700;
	letter-spacing: 0.06em;
	text-transform: uppercase;
}

.InputSrTable .btnArea {
	position: sticky;
	right: 0px;
	background-color: #ffffff;
	border-left: 1px solid #e2e8f0;
	box-shadow: -6px 0 15px rgba(0, 0, 0, 0.02);
	padding: 8px 14px;
	z-index: 5;
}

.InputSrTable tr:nth-child(even) .btnArea {
	background-color: #f0f5fa;
}

.InputSrTable tr:hover .btnArea {
	background-color: #e2edf8;
}

/* Row action buttons container */
.InputSrTable .row-action-buttons {
	display: flex;
	align-items: center;
	justify-content: center;
	gap: 8px;
	position: relative;
}

.InputSrTable .action-trigger-btn.p-button {
	width: 32px;
	height: 32px;
	padding: 0;
	background: transparent;
	border: none;
	color: #64748b;
	transition: all 0.2s ease;
}
.InputSrTable .action-trigger-btn.p-button:hover {
	background: rgba(0, 0, 0, 0.05);
	color: #0f172a;
}

/* Action buttons popover menu - Glassmorphic */
.InputSrTable .action-buttons-popover {
	display: flex;
	align-items: center;
	gap: 8px;
	background: rgba(255, 255, 255, 0.9);
	backdrop-filter: blur(8px) saturate(180%);
	-webkit-backdrop-filter: blur(8px) saturate(180%);
	border: 1px solid rgba(226, 232, 240, 0.8);
	border-radius: 10px;
	padding: 6px;
	box-shadow: 0 10px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.05);
	position: absolute;
	right: 46px;
	z-index: 100;
	animation: slideIn 0.2s cubic-bezier(0.34, 1.56, 0.64, 1);
}

@keyframes slideIn {
	from {
		opacity: 0;
		transform: translateX(8px) scale(0.95);
	}
	to {
		opacity: 1;
		transform: translateX(0) scale(1);
	}
}

.InputSrTable .action-btn.p-button {
	width: 28px;
	height: 28px;
	padding: 0;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.InputSrTable .action-btn.p-button:hover {
	background: #f1f5f9;
	transform: scale(1.05);
}

.InputSrTable .action-btn.p-button-danger:hover {
	background: #fee2e2;
	color: #ef4444;
	transform: scale(1.05);
}

/* Notes & Autocomplete custom styling overrides */
.InputSrTable .container-notes {
	background-color: transparent !important;
}

.InputSrTable .author-div {
	background-color: transparent !important;
}

/* Checkbox Style Enhancements */
.checkbox-wrapper-29 .checkbox {
	user-select: none;
}
.checkbox-wrapper-29 .checkbox__label {
	transition: all 0.2s ease;
}
.checkbox-wrapper-29 .checkbox__label:after {
	border-radius: 6px;
	border: 2px solid #cbd5e1;
	background: #ffffff;
	transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}
.checkbox-wrapper-29:hover .checkbox__label:after {
	border-color: #94a3b8;
	transform: scale(1.05);
}
.checkbox-wrapper-29 .checkbox__input:checked ~ .checkbox__label:after {
	background: linear-gradient(135deg, #10b981, #059669) !important;
	border-color: #059669 !important;
	transform: scale(1);
}
</style>
